import { render, staticRenderFns } from "./ArticlesItemView.vue?vue&type=template&id=4a9ffc52&scoped=true&"
import script from "./ArticlesItemView.vue?vue&type=script&lang=js&"
export * from "./ArticlesItemView.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesItemView.vue?vue&type=style&index=0&id=4a9ffc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9ffc52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VSheet})
